module.exports = __webpack_public_path__ + "static/media/logo.3c3b8feb.gif";